import { en } from './en.js'

export const pt = structuredClone(en)

pt.visualGameAdmin.conversionFunnelDevices = {'label': 'Dispositivos de origem', 'all': 'Todos', 'desktop': 'Computador', 'mobile': 'Celular', 'tablet': 'Tablet'}

pt.visualGameAdmin.pageFunnel = {'button': 'Ver funil de páginas', 'title': 'Funil de páginas', 'home': 'Início', 'auth': 'Entrada ou cadastro', 'game': 'Página de jogo', 'note': 'Sessões que percorrem as etapas na ordem, por data e dispositivo. Inclui o diálogo de login no PC. Aberturas históricas sem registro não podem ser recuperadas.', 'loading': 'Carregando…', 'error': 'Falha ao carregar', 'sessions': 'sessões'}

pt.visualGameAdmin.pageFunnel.viewUsers = 'Ver usuários'
pt.visualGameAdmin.pageFunnel.peopleUnit = 'usuários'
pt.visualGameAdmin.pageFunnel.timesUnit = 'vezes'

pt.visualGameAdmin.pageFunnel.userFilter_all = 'Funil: cadastros ou logins'

pt.visualGameAdmin.pageFunnel.userFilter_sign_up = 'Funil: cadastros no período'

pt.visualGameAdmin.pageFunnel.userFilter_login = 'Funil: logins no período'

pt.visualGameAdmin.usageActivity = {
  "title": "Uso do site · Atividade",
  "button": "Ver detalhes",
  "all": "Todas as atividades",
  "search": "Buscar usuário, jogo ou ID",
  "user": "Usuário",
  "game": "Jogo",
  "kind": "Atividade",
  "status": "Estado",
  "time": "Data",
  "detail": "Ver registro",
  "empty": "Nenhum registro encontrado",
  "loading": "Carregando…",
  "error": "Falha ao carregar",
  "note": "As entradas usam eventos próprios e podem diferir do GA4. Textos e partidas não registrados não são inferidos.",
  "limit": "Últimos 1000 registros. Reduza o período para ver outros.",
  "text_input": "Entrada de texto",
  "voice_input": "Entrada de voz",
  "slice_video": "Geração de clipe",
  "global_video": "Geração de vídeo completo",
  "free_game": "Geração de jogo grátis"
}

Object.assign(pt.visualGameAdmin.usageActivity, {
  "status_queued": "Na fila",
  "status_running": "Em andamento",
  "status_ready": "Concluído",
  "status_failed": "Falhou",
  "status_submitting": "Enviando",
  "status_submitted": "Enviado",
  "status_ok": "Sucesso",
  "status_error": "Falhou",
  "status_generating": "Gerando",
  "status_generation_failed": "Falha na geração",
  "status_pending_review": "Em revisão",
  "status_review_rejected": "Rejeitado",
  "status_published": "Publicado",
  "status_archived": "Arquivado"
})

pt.visualGameAdmin.usageActivity.records = 'registros'

pt.visualGameAdmin.paypointActivity = {
  "title": "Pontos de pagamento · Detalhes",
  "all": "Todos",
  "game": "Página",
  "kind": "Contexto",
  "status": "Motivo",
  "note": "Eventos próprios podem diferir do GA4. Abrir o diálogo de vídeo não indica saldo insuficiente. Registros históricos não incluem saldo, custo ou ID da partida.",
  "billing_paypoint_gameplay": "Jogo",
  "billing_paypoint_ending_video": "Vídeo final",
  "billing_paypoint_story_video": "Vídeo da história",
  "status_insufficient_balance": "Créditos insuficientes",
  "status_dialog_open": "Diálogo de geração aberto"
}

pt.visualGameAdmin.paypointActivity.search = 'Buscar usuário, página ou ID'

pt.visualGameAdmin.orderDrilldown = {
  "button": "Ver pedidos",
  "dateField": "Referência de data",
  "created_at": "Data de criação",
  "paid_at": "Data de pagamento"
}

Object.assign(pt.visualGameAdmin.orderDrilldown, {
  "since": "Data inicial",
  "until": "Data final"
})

pt.visualGameAdmin.orderDrilldown.updated_at = 'Data de atualização do status'

pt.visualGameAdmin.trafficBaseline = {
  "confirmed": "Aumento confirmado",
  "first": "Visualizações iniciais (a confirmar)",
  "missing": "Sem referência; aumento incompleto",
  "note": "Sem registro anterior ao período, as visualizações iniciais ficam separadas do aumento confirmado. A data de observação não é a de publicação.",
  "observed": "Primeira observação",
  "filter": "Sem referência",
  "unchanged": "Sem aumento (referência completa)",
  "later": "Aumento após primeira observação"
}
